import { LoadingOverlay } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useParams } from 'react-router-dom';
import { SmallModal } from '../../../components/SmallModal';
import { mutate } from '../../../util/api/mutate';

interface OrganisationEditorModal {
	close: () => void;
	opened: boolean;
	triggerListUpdate: () => void;
	posMessageId: string;
}

export function DeletePosMessageModal({
	opened,
	close,
	triggerListUpdate,
	posMessageId,
}: OrganisationEditorModal) {
	const { organisation } = useParams();

	const deletePosMutation = mutate<boolean>(
		`${organisation}/pos-messages/delete/${posMessageId}`,
	);

	const [
		showDeleteComplete,
		{ open: openDeleteComplete, close: closeDeleteComplete },
	] = useDisclosure(false);

	const cancel = () => {
		close();
	};

	const complete = () => {
		triggerListUpdate();
		closeDeleteComplete();
		close();
	};

	const confirm = async () => {
		await deletePosMutation.mutateAsync().then(() => openDeleteComplete());
	};

	return (
		<>
			<LoadingOverlay visible={false} />
			<SmallModal
				isOpen={opened}
				close={cancel}
				title={'Delete POS Message'}
				body={
					'Are you sure you want to delete a POS message. Click Ok to confirm...'
				}
				onComplete={async () => await confirm()}
			/>
			<SmallModal
				isOpen={showDeleteComplete}
				close={complete}
				title={'POS Message Deleted!'}
				body={'A POS Message deleted. Click Ok to continue...'}
			/>
		</>
	);
}
